<template>
    <div class="admin">
        <form style="margin-bottom:10px;">
            <a-row type="flex" justify="start">
                <a-col :span="20">
                    <a-row :gutter="10">
                        <a-col :span="5">
                            <a-input v-model="keyword" placeholder="请输入产品标题" />
                        </a-col>
                        <a-col :span="5">
                            <a-select v-model="category_id" placeholder="全部分类" allow-clear style="width:100%;">
                                <a-select-option v-for="c in categories" :key="c.id" :value="c.id">{{ c.name }}</a-select-option>
                            </a-select>
                        </a-col>
                        <a-col :span="4">
                            <a-select v-model="type" placeholder="全部类型" allow-clear style="width:100%;">
                                <a-select-option :value="1">出售</a-select-option>
                                <a-select-option :value="2">求购</a-select-option>
                            </a-select>
                        </a-col>
                        <a-col :span="5">
                            <a-select v-model="audit_status" placeholder="全部审核状态" allow-clear style="width:100%;">
                                <a-select-option :value="0">待审核</a-select-option>
                                <a-select-option :value="1">已通过</a-select-option>
                                <a-select-option :value="2">已驳回</a-select-option>
                            </a-select>
                        </a-col>
                        <a-col :span="4">
                            <a-button type="primary" @click="get_data()">搜索</a-button>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col :span="2">
                    <a-button
                        type="primary"
                        @click="add_model = true; reset_info()"
                        v-if="$Func.check_rank('lithium_add')"
                    >添加信息</a-button>
                </a-col>
            </a-row>
        </form>
        <a-table
            :columns="columns"
            :data-source="tableData"
            @change="change_filter"
            :loading="loading"
            :pagination="page"
            bordered
        >
            <template slot="cover_tpl" slot-scope="text, record">
                <img v-if="record.images" :src="base_url + record.images.split(',')[0]" style="width:60px;height:60px;object-fit:cover;" />
                <span v-else>-</span>
            </template>
            <template slot="type_tpl" slot-scope="text">
                <a-tag :color="text == 2 ? 'blue' : 'green'">{{ text == 2 ? '求购' : '出售' }}</a-tag>
            </template>
            <template slot="audit_tpl" slot-scope="text, record">
                <a-tooltip :title="record.audit_remark || ''">
                    <a-tag :color="text == 1 ? 'green' : (text == 2 ? 'red' : 'orange')">
                        {{ text == 1 ? '已通过' : (text == 2 ? '已驳回' : '待审核') }}
                    </a-tag>
                </a-tooltip>
            </template>
            <template slot="user_tpl" slot-scope="text, record">
                <span v-if="record.uid > 0">{{ record.user_nickname || record.user_mobile || ('用户' + record.uid) }}</span>
                <span v-else>后台添加</span>
            </template>
            <template slot="status_tpl" slot-scope="text">
                <a-tag :color="text == 1 ? 'green' : 'red'">{{ text == 1 ? '启用' : '禁用' }}</a-tag>
            </template>
            <template slot="operation" slot-scope="text, record">
                <a @click="() => { update_data(record) }" v-if="$Func.check_rank('lithium_edit')">编辑</a>
                <template v-if="record.audit_status != 1 && $Func.check_rank('lithium_edit')">
                    <a-divider type="vertical" />
                    <a @click="() => { audit_data(record, 1) }">通过</a>
                    <a-divider type="vertical" />
                    <a @click="() => { audit_data(record, 2) }">驳回</a>
                </template>
                <a-divider type="vertical" />
                <a @click="() => { delete_data(record) }" v-if="$Func.check_rank('lithium_del')">删除</a>
            </template>
        </a-table>
        <a-drawer
            title="锂电市场信息"
            :width="750"
            :maskStyle="{ backgroundColor: '#00000010' }"
            :visible="add_model"
            :body-style="{ paddingBottom: '80px' }"
            :destroyOnClose="true"
            @close="add_model = false"
        >
            <a-form-model :model="info_add" :rules="add_rules" layout="vertical" @submit="add_data" ref="add_form">
                <a-form-model-item ref="title" prop="title" label="产品标题">
                    <a-input v-model="info_add.title" placeholder="请输入产品标题" />
                </a-form-model-item>
                <a-form-model-item ref="category_id" label="所属分类">
                    <a-select v-model="info_add.category_id" placeholder="请选择分类" style="width:100%;">
                        <a-select-option v-for="c in categories" :key="c.id" :value="c.id">{{ c.name }}</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item ref="quantity" label="数量/规格">
                            <a-input v-model="info_add.quantity" placeholder="如：约3.2吨 / 批量供应" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item ref="location" label="地区">
                            <a-input v-model="info_add.location" placeholder="如：广东·惠州" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item ref="price" label="价格">
                            <a-input v-model="info_add.price" placeholder="如：面议 / 电话议价" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item ref="contact" label="联系方式">
                            <a-input v-model="info_add.contact" placeholder="如：0752-0000000" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-form-model-item ref="type" label="类型">
                    <a-radio-group v-model="info_add.type">
                        <a-radio :value="1">出售</a-radio>
                        <a-radio :value="2">求购</a-radio>
                    </a-radio-group>
                </a-form-model-item>
                <a-form-model-item ref="cover" label="封面图（列表展示用）">
                    <div class="cover-upload-wrap">
                        <div class="cover-preview-box" v-if="cover_preview">
                            <img :src="cover_preview" class="cover-preview-img" />
                            <a-icon type="close" class="cover-remove" @click="remove_cover" />
                        </div>
                        <a-upload
                            v-else
                            list-type="picture-card"
                            :show-upload-list="false"
                            :custom-request="cover_upload"
                            accept="image/*"
                        >
                            <div>
                                <a-icon type="plus" />
                                <div class="ant-upload-text">上传封面</div>
                            </div>
                        </a-upload>
                        <span class="cover-tip">不设置则默认取多图第一张</span>
                    </div>
                </a-form-model-item>
                <a-form-model-item ref="images" label="产品图片（多图，最多9张）">
                    <div class="image-upload-grid">
                        <div class="image-item" v-for="(img, i) in image_list" :key="i">
                            <img :src="full_url(img)" class="image-thumb" @click="open_preview(img)" />
                            <a-icon type="close" class="image-remove" @click="remove_image(i)" />
                        </div>
                        <a-upload
                            v-if="image_list.length < 9"
                            list-type="picture-card"
                            :show-upload-list="false"
                            :custom-request="image_upload"
                            accept="image/*"
                            multiple
                        >
                            <div>
                                <a-icon type="plus" />
                                <div class="ant-upload-text">上传图片</div>
                            </div>
                        </a-upload>
                    </div>
                </a-form-model-item>
                <a-form-model-item ref="content" label="详情描述">
                    <AEditor v-model="info_add.content" />
                </a-form-model-item>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item ref="sort" label="排序">
                            <a-input-number style="width: 100%" :min="0" v-model="info_add.sort" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item ref="status" label="状态">
                            <a-switch
                                v-model="info_add.status"
                                :checked="info_add.status == 1"
                                :checked-children="'启用'"
                                :un-checked-children="'禁用'"
                                @change="(val) => { info_add.status = val ? 1 : 0 }"
                            />
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <div
                    :style="{
                        position: 'absolute',
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                        zIndex: 1,
                    }"
                >
                    <a-button :style="{ marginRight: '8px' }" @click="add_model = false">取消</a-button>
                    <a-button type="primary" html-type="submit">确定</a-button>
                </div>
            </a-form-model>
        </a-drawer>
        <a-modal :visible="preview_visible" :footer="null" :width="480" @cancel="preview_visible = false">
            <div class="preview-box">
                <img alt="preview" class="preview-img" :src="preview_url" />
            </div>
        </a-modal>
    </div>
</template>

<script>
import Func from '../../common/func';
import AEditor from '../../components/AEditor';

const columns = [
    { title: '#', dataIndex: 'id', key: 'id', width: 70 },
    { title: '封面', dataIndex: 'images', key: 'images', width: 80, scopedSlots: { customRender: 'cover_tpl' } },
    { title: '标题', dataIndex: 'title', key: 'title' },
    { title: '分类', dataIndex: 'category_name', key: 'category_name', width: 120 },
    { title: '地区', dataIndex: 'location', key: 'location', width: 120 },
    { title: '价格', dataIndex: 'price', key: 'price', width: 100 },
    { title: '类型', dataIndex: 'type', key: 'type', width: 80, scopedSlots: { customRender: 'type_tpl' } },
    { title: '审核状态', dataIndex: 'audit_status', key: 'audit_status', width: 100, scopedSlots: { customRender: 'audit_tpl' } },
    { title: '发布者', dataIndex: 'uid', key: 'uid', width: 120, scopedSlots: { customRender: 'user_tpl' } },
    { title: '状态', dataIndex: 'status', key: 'status', width: 80, scopedSlots: { customRender: 'status_tpl' } },
    { title: '操作', dataIndex: 'id', width: 220, key: 'operation', scopedSlots: { customRender: 'operation' } },
];

export default {
    name: 'LithiumInfo',
    components: { AEditor },
    data() {
        return {
            base_url: Func.pic_url,
            columns,
            keyword: '',
            category_id: undefined,
            type: undefined,
            audit_status: undefined,
            categories: [],
            tableData: [],
            loading: false,
            add_model: false,
            info_add: { id: 0, status: 1, type: 1, sort: 0 },
            image_list: [],
            preview_visible: false,
            preview_url: '',
            add_rules: {
                title: [{ required: true, message: '请输入产品标题', trigger: 'blur' }],
            },
            page: { current: 1, total: 0, pageSize: 10 },
        };
    },
    computed: {
        cover_preview() {
            if (!this.info_add.cover) return '';
            return this.info_add.cover.indexOf('http') === 0
                ? this.info_add.cover
                : this.base_url + this.info_add.cover;
        },
    },
    mounted() {
        this.get_categories();
        this.get_data();
    },
    methods: {
        get_categories() {
            Func.url_get({ action: 'lithium.all_category' }, (res) => {
                if (res.error === 0) this.categories = res.info;
            });
        },
        change_filter(pagination) {
            this.get_data(pagination.current);
        },
        get_data(page, tip) {
            if (!page) page = this.page.current || 1;
            if (!tip) this.loading = true;

            Func.url_get(
                {
                    action: 'lithium.product_index',
                    keyword: this.keyword,
                    category_id: this.category_id || 0,
                    type: this.type || 0,
                    audit_status: (this.audit_status === undefined || this.audit_status === null) ? '' : this.audit_status,
                    page: page,
                },
                (res) => {
                    if (res.error === 0) {
                        this.tableData = res.info.list;
                        this.page = {
                            pageSize: 10,
                            total: res.info.foot.total,
                            current: parseInt(res.info.foot.current),
                        };
                        this.loading = false;
                    } else {
                        this.$message.error(res.info);
                    }
                }
            );
        },
        reset_info() {
            this.info_add = { id: 0, status: 1, type: 1, sort: 0 };
            this.image_list = [];
        },
        full_url(u) {
            if (!u) return '';
            return u.indexOf('http') === 0 ? u : this.base_url + u;
        },
        cover_upload(options) {
            const file = options.file;
            Func.url_form(
                { action: 'api.ed_upload', imgFile: file },
                (res) => {
                    if (res.error === 0) {
                        this.info_add.cover = res.url;
                        this.$message.success('封面上传成功');
                        if (options.onSuccess) options.onSuccess(res);
                    } else {
                        this.$message.error(res.message || res.info || '上传失败');
                        if (options.onError) options.onError(res);
                    }
                }
            );
        },
        remove_cover() {
            this.info_add.cover = '';
        },
        image_upload(options) {
            const file = options.file;
            if (this.image_list.length >= 9) {
                this.$message.warning('最多上传9张图片');
                if (options.onError) options.onError(new Error('max'));
                return;
            }
            Func.url_form(
                { action: 'api.ed_upload', imgFile: file },
                (res) => {
                    if (res.error === 0) {
                        this.image_list.push(res.url);
                        this.$message.success('图片上传成功');
                        if (options.onSuccess) options.onSuccess(res);
                    } else {
                        this.$message.error(res.message || res.info || '上传失败');
                        if (options.onError) options.onError(res);
                    }
                }
            );
        },
        remove_image(i) {
            this.image_list.splice(i, 1);
        },
        open_preview(u) {
            this.preview_url = this.full_url(u);
            this.preview_visible = true;
        },
        add_data(e) {
            e.preventDefault();
            this.$refs.add_form.validate((valid) => {
                if (valid) {
                    this.info_add.images = this.image_list.join(',');
                    Func.url_post(
                        {
                            action: this.info_add.id ? 'lithium.product_save' : 'lithium.product_add',
                            ...this.info_add,
                        },
                        (res) => {
                            if (res.error === 0) {
                                this.$message.success(res.info);
                                this.add_model = false;
                                this.image_list = [];
                                this.get_data(1, true);
                            } else {
                                this.$message.error(res.info);
                            }
                        }
                    );
                }
            });
        },
        update_data(record) {
            const item = JSON.parse(JSON.stringify(record));
            Func.url_get({ action: 'lithium.product_find', id: item.id }, (res) => {
                if (res.error !== 0) {
                    this.$message.error(res.info);
                    return;
                }
                this.info_add = res.info;
                this.image_list = (res.info.images || '').split(',').filter(Boolean);
                this.add_model = true;
            });
        },
        delete_data(item) {
            if (confirm('确定要删除该信息吗？') == true) {
                Func.url_get({ action: 'lithium.product_del', id: item.id }, (res) => {
                    if (res.error === 0) {
                        this.$message.success(res.info);
                        this.get_data(1, true);
                    } else {
                        this.$message.error(res.info);
                    }
                });
            }
        },
        // 审核：status 1=通过 2=驳回
        audit_data(record, status) {
            const submit = (remark) => {
                Func.url_post(
                    { action: 'lithium.product_audit', id: record.id, audit_status: status, audit_remark: remark || '' },
                    (res) => {
                        if (res.error === 0) {
                            this.$message.success(res.info);
                            this.get_data(null, true);
                        } else {
                            this.$message.error(res.info);
                        }
                    }
                );
            };
            if (status === 1) {
                this.$confirm({
                    title: '确认通过审核？',
                    content: '通过后将进入小程序/APP「锂电市场」列表，并推送给订阅了锂电产品的用户',
                    onOk() {
                        submit('');
                    },
                });
            } else {
                const remark = window.prompt('请输入驳回原因（会展示给发布者）', '');
                if (remark === null) return;
                if (!remark.trim()) {
                    this.$message.warning('驳回原因不能为空');
                    return;
                }
                submit(remark.trim());
            }
        },
    },
};
</script>

<style scoped>
.image-upload-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}
.image-item {
    position: relative;
    width: 72px;
    height: 72px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    overflow: hidden;
    background: #fafafa;
}
.image-thumb {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: zoom-in;
}
.image-remove {
    position: absolute;
    top: 0;
    right: 0;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    color: #fff;
    background: rgba(0, 0, 0, 0.55);
    cursor: pointer;
}
.image-upload-grid >>> .ant-upload.ant-upload-select-picture-card {
    width: 72px;
    height: 72px;
    margin: 0;
}
.preview-box {
    display: flex;
    align-items: center;
    justify-content: center;
}
.preview-img {
    max-width: 100%;
    max-height: 60vh;
    object-fit: contain;
}
.cover-upload-wrap {
    display: flex;
    align-items: center;
    gap: 12px;
}
.cover-preview-box {
    position: relative;
    width: 72px;
    height: 72px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    overflow: hidden;
    background: #fafafa;
    flex: 0 0 72px;
}
.cover-preview-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.cover-remove {
    position: absolute;
    top: 0;
    right: 0;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    color: #fff;
    background: rgba(0, 0, 0, 0.55);
    cursor: pointer;
}
.cover-tip {
    color: #999;
    font-size: 12px;
    line-height: 1.4;
}
.cover-upload-wrap >>> .ant-upload.ant-upload-select-picture-card {
    width: 72px;
    height: 72px;
    margin: 0;
    flex: 0 0 72px;
}
</style>
